/**
 * Public identifiers + content for the FOMO ("teammates using Rovo") nudge.
 *
 * Source of truth: FOMO Nudge doc (Confluence page 7094179434).
 * Consumed by both the Confluence hook (page-rovo-config-common) and the Jira
 * sibling provider (ai-rovo/actions-route-provider).
 *
 * NOTE: Statsig gate / experiment identifiers are intentionally NOT exported
 * from this package. Both `fg()` (Confluence) and `expVal()` (Jira) require
 * string literals for static analysis — consuming a variable breaks the
 * tooling. Each product uses the strings inline:
 *   gate:       'rovo_button_collab_teammates_fomo_nudge_enabled'
 *   experiment: 'rovo_button_collab_teammates_fomo_nudge' / 'isEnabled'
 */

/** Stable id used for analytics, store de-duping, and nudgeContext matching. */
export const FOMO_NUDGE_ID = 'rovo-collab-teammates-fomo-nudge';

/**
 * Verbatim prompt sent to Rovo Chat when the user clicks the nudge.
 * Source: FOMO Nudge doc § "Smallest 1-week version".
 */
export const FOMO_STATIC_PROMPT = 'Based on my work, give me 3 ways Rovo can help me this week.';

/**
 * "Show once" persistence key. The product hooks are responsible for the
 * actual read/write — Confluence uses raw localStorage, Jira uses
 * AtlBrowserStorageSession with fireErrorAnalytics wrapping. Keeping the
 * key here ensures the two products can't accidentally diverge.
 */
export const FOMO_NUDGE_DISMISSAL_STORAGE_KEY = 'rovo-collab-teammates-fomo-nudge:dismissed';
